import {MediaType} from '../../../../types/TaskModuleMediaData';

export class QuizMedia {
    constructor(public mediaType: MediaType | undefined,
                public imageUrl: string | undefined,
                public mediaUrl: string | undefined) {
    }
}
